"use client";
import { useEffect, useState } from "react";

export default function ArticleActions({ postId, slug, likeCount = 0 }) {
    const [mounted, setMounted] = useState(false);
    const [shareUrl, setShareUrl] = useState("");
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setMounted(true);
        try {
            setShareUrl(`${location.origin}/articles/${slug}`);
        } catch {}
    }, [slug]);

    const handleShare = async () => {
        const url = shareUrl || `${location.origin}/articles/${slug}`;
        try {
            if (navigator.share) {
                await navigator.share({ title: document.title, url });
            } else {
                await navigator.clipboard.writeText(url);
                setCopied(true);
                window.setTimeout(() => setCopied(false), 1400);
            }
        } catch (err) {
            console.error("Share failed", err);
        }
    };

    if (!mounted) return null;

    return (
        <>
            <div className="mt-8">
                <div className="relative rounded-2xl p-[1px] bg-gradient-to-br from-zinc-200/80 via-zinc-100/40 to-transparent dark:from-zinc-700/60 dark:via-zinc-800/30">
                    <div
                        className="rounded-2xl border border-zinc-200/70 dark:border-zinc-700/60
                                    bg-white/60 dark:bg-zinc-900/60 backdrop-blur-md
                                    px-3 sm:px-5 py-3 flex items-center justify-between gap-3"
                    >
                        <button
                            onClick={handleShare}
                            className="group inline-flex items-center gap-2 rounded-xl
                                       px-3.5 py-2 text-sm font-medium
                                       bg-zinc-50/80 hover:bg-zinc-100 active:bg-zinc-200/70
                                       dark:bg-zinc-800/70 dark:hover:bg-zinc-700/70 dark:active:bg-zinc-700
                                       text-zinc-800 dark:text-zinc-100
                                       shadow-sm hover:shadow transition
                                       focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-400/60 dark:focus-visible:ring-zinc-500/60"
                            aria-label="Share this article"
                            title="Share"
                        >
                            <ShareIcon className="shrink-0" />
                            <span className="hidden xs:inline">Share</span>
                        </button>

                        <div
                            className="text-xs sm:text-sm text-zinc-500 dark:text-zinc-400 select-none"
                            aria-live="polite"
                        >
                            {likeCount > 0 ? (
                                <span>
                                    <strong className="font-semibold text-zinc-700 dark:text-zinc-200">
                                        {likeCount}
                                    </strong>{" "}
                                    {likeCount === 1
                                        ? "person liked this"
                                        : "people liked this"}
                                </span>
                            ) : (
                                <span>Enjoyed it? Share it.</span>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {copied && (
                <div
                    role="status"
                    aria-live="polite"
                    className="fixed bottom-4 left-1/2 -translate-x-1/2
                               px-3.5 py-2.5 text-sm rounded-lg shadow-lg
                               bg-zinc-900 text-white/90 dark:bg-zinc-800
                               border border-white/10"
                >
                    Link copied
                </div>
            )}
        </>
    );
}

function ShareIcon({ className = "" }) {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className={className}
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7" />
            <path d="M12 16V4" />
            <path d="m7 9 5-5 5 5" />
        </svg>
    );
}
